import { AfterViewInit, Component, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { environment } from "../../../../environments/environment";
import { ArkUserType, ClientModel, ClientPermissionViewModel, ClientUserRolesViewModel, ClientViewModel } from "../../../core/api/models";
import { ClientsApiService } from "../../../core/api/services";
import { Utils } from "../../../core/utils";
import { AuthService } from "../../../main/auth.service";
import { AlertService } from "../../../shared/services/alert.service";
import { ListboxModule } from 'primeng/listbox';

@Component({
  selector: 'app-client-permissions',
  templateUrl: './client-permissions.component.html',
  styleUrl: './client-permissions.component.css',
  standalone: false
})
export class ClientPermissionsComponent implements OnInit, AfterViewInit {


  public pageTitle: string = 'Permissions';

  userAndRoles: any;

  currentItem?: ClientModel;
  loading: boolean = true;
  permissions: ClientPermissionViewModel[] = []

  currentPermission: any;

  constructor(private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private apiService: ClientsApiService,
    private sanitizer: DomSanitizer) {
    this.userAndRoles = {};
  }


  ngOnInit(): void {


    this.route.paramMap.subscribe((params: ParamMap) => {
      let ID = + (params.get('ID') || '0');
      
      if (ID > 0) {
        
        this.apiService.Get({ body: { id: ID } })
          .forEach(data => {
            this.loading = false;
            this.currentItem = data;

          }).catch(
            err => {
              this.alertService.error(Utils.getAjaxError(err));

            });

        this.apiService.GetClientPermissions({  clientID: ID  })
          .forEach(data => {
            this.loading = false;
            this.permissions = data;

          }).catch(
            err => {
              this.alertService.error(Utils.getAjaxError(err));

            });

        
        this.loading = true;
        this.apiService.GetClientUserRoles({ clientID: ID })
          .forEach(
            (result) => {
              this.userAndRoles = result;
              this.loading = false;
            }).catch(
              err => {
                this.alertService.error(Utils.getAjaxError(err));
                this.loading = false;
              });
      }
    });


    this.authService.checkIfAutorized([ArkUserType.Marketing, ArkUserType.Admin, ArkUserType.Impersonator]);

  }

  getUsers() {
    return this.userAndRoles?.Users;
  }

  ngAfterViewInit(): void {


  }

  save(): void {
    this.loading = true;
    console.log('Saving client permission data:', this.currentPermission);
    //var array: ClientPermissionViewModel[] = new Array(this.currentPermission) 
    this.apiService.SaveClientPermission({
      clientID: this.currentItem?.ID ?? 0,
      body: this.currentPermission
    })
      .subscribe(
        {
          next: (response) => {
            console.log('Update Client Permission:', response);
            this.alertService.success(`Client Permissions saved successfully`);
            this.currentPermission = null;
            this.loading = false;
          },
          error: (error) => {
            console.error('Error updating client permission:', error);
            this.alertService.error('Error updating Client Permission - ' + error.Message);
            this.loading = false;
          }
        }
      );
  }

  getClientLogo(client: ClientViewModel | ClientModel | null | undefined, type: string = 'Print'): any {

    var siteName = client?.SiteName?.toLocaleLowerCase();
    if (siteName == 'optodev')
      siteName = 'beta';

    //return this.sanitizer.bypassSecurityTrustUrl(`https://${siteName}.${environment.baseDomain}/Login/DisplayLogo/${siteName}.png`);
    return this.sanitizer.bypassSecurityTrustUrl(`https://${siteName}.${environment.baseDomain}/Login/${type}Logo/${siteName}.png`);
  }
  clickItem(item: string) {
    this.router.navigate([`/clients/${this.currentItem?.ID}/${item}`]);
  }

}
